import { useMutation, useQueryClient } from 'react-query';
import { useSnackbar } from 'notistack';
import { useService } from 'shared/providers';
import { ContractDocument, ContractRouteParams } from 'shared/types';
import { useParams } from 'react-router-dom';

export function useUpdateContract() {
  const { contractService } = useService();
  const { enqueueSnackbar } = useSnackbar();
  const { masterCustomer, abgBrand } = useParams<ContractRouteParams>();
  const queryClient = useQueryClient();
  const mutation = useMutation<{ operationId: string }, Error, ContractDocument>(
    request => contractService.updateContract(request),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(['contracts', { customer: masterCustomer, brand: abgBrand }]);
        queryClient.invalidateQueries('contract');
        enqueueSnackbar('Contract was updated', { variant: 'success' });
      },
      onError: () => {
        enqueueSnackbar('Contract was not updated', { variant: 'error' });
      },
    }
  );

  return mutation;
}
